import inputFilterDirective from './inputFilter'

const directives = { inputFilterDirective }

export default {
  // eslint-disable-next-line no-unused-vars
  install(Vue, options) {
    Object.values(directives).forEach(directive =>
      Vue.directive(directive.name, directive.directive)
    )
  },
}
